import React from 'react';
import { Route } from "react-router-dom";
import GuestLayout from "../scenes/layouts/guest";
import { GuestHome } from "../scenes/pages/guestHome";
import RequireGuest from "../helpers/requireGuest";

const GuestRoutes = () => (
    <Route element={<RequireGuest />}>
        <Route element={<GuestLayout />}>
            <Route path="/" element={<GuestHome />} />
        </Route>
    </Route>
);

export default GuestRoutes;